<script setup lang="ts">
import AboutPage from '@/components/about-page'

defineOptions({
  name: 'AboutView',
})
</script>

<template>
  <AboutPage />
</template>
